module.exports = __webpack_public_path__ + "img/dsc-5291.4e8e268d.jpg";